import React from 'react';
import {NavLink} from 'react-router-dom';
import {PAGES_URL} from '../../../helpers/constants';
import {connect} from 'react-redux';
import * as Actions from '../../../store/actions';

const ROUTES = [
  {
    name: 'Transaction History',
    path: PAGES_URL.SETTINGS_BILLING,
    permission: 'viewHistory',
  },
  {
    name: 'API Calls',
    path: PAGES_URL.SETTINGS_BILLING_PRICING,
    permission: 'viewLogs',
  },
];

function BillingsLayout({auth: {userDetails}, children}) {
  return (
    <>
      <div className="mt-6">
        <div className="rounded-md bg-[#F7F7F7] w-fit p-1 flex items-center gap-2 overflow-x-auto">
          {ROUTES.map((route, index) => (
            <NavLink
              key={index}
              end
              to={route.path}
              className={({isActive}) =>
                `px-7 py-1.5 min-h-8 text-sm flex items-center justify-center rounded-lg shadow-[0px_4px_32px_-4px,rgba(199,196,196,0.18)] ${
                  isActive
                    ? 'text-black bg-white shadow-tabs'
                    : 'text-grey-500 bg-transparent'
                }`
              }
              style={{
                pointerEvents: userDetails?.permissions?.billingPermissions[
                  route.permission
                ]
                  ? 'auto'
                  : 'none',
              }}
            >
              {route.name}
            </NavLink>
          ))}
        </div>
      </div>
      {children}
    </>
  );
}

export default connect(state => state, Actions)(BillingsLayout);
